import type { AvailabilityWindowState } from '@ooh/contracts';

/**
 * Shared `AvailabilityWindowState` -> `Badge` tone map. Previously duplicated
 * between `features/reservations/components/availability-window-list.tsx`
 * and `features/availability-import/components/interpreted-rows-table.tsx`
 * (CU-86cbafj4j review finding) — both surfaces must stay in sync if a new
 * state is ever added.
 */
export const availabilityWindowStateVariantMap: Record<
  AvailabilityWindowState,
  'success' | 'destructive'
> = {
  FREE: 'success',
  UNAVAILABLE: 'destructive',
};
